<template>
  <div>
    <basic-container>
      <avue-crud :option="option" :data="list" ref="crud" @refresh-change="refreshChange">
        <!-- 自定义搜索框 -->
        <template slot="mySearch">
          <div class="search-contain">
            <div class="search-left">
              <el-date-picker clearable style="width: 200px!important;margin-right: .625rem;"
                v-model="searchParams.addStartTime" type="daterange" range-separator=" " start-placeholder="下单时间"
                align="right" value-format="yyyy-MM-dd" unlink-panels :picker-options="{
                  disabledDate(time) {
                    return time.getTime() > Date.now();
                  }
                }"></el-date-picker>
              <el-input v-model="searchParams.orderSearch" size="medium"
                style="width: 200px !important;margin-right: .625rem;" clearable placeholder="订单编号/商户单号/交易流水号"></el-input>
              <el-input v-model="searchParams.userSearch" size="medium"
                style="width: 200px !important;margin-right: .625rem;" clearable placeholder="用户账户/UID/UUID"></el-input>
              <el-date-picker clearable style="width: 200px !important;margin-right: .625rem;"
                v-model="searchParams.payStartTime" type="daterange" range-separator=" " start-placeholder="支付时间"
                align="right" value-format="yyyy-MM-dd" unlink-panels :picker-options="{
                  disabledDate(time) {
                    return time.getTime() > Date.now();
                  }
                }"></el-date-picker>
              <el-date-picker clearable style="width: 200px !important;margin-right: .625rem;"
                v-model="searchParams.refundStartTime" type="daterange" range-separator=" " start-placeholder="退款时间"
                align="right" value-format="yyyy-MM-dd" unlink-panels :picker-options="{
                  disabledDate(time) {
                    return time.getTime() > Date.now();
                  }
                }"></el-date-picker>
              <el-select v-model="searchParams.payMethod" size="medium"
                style="width: 200px !important;margin-right: .625rem;" clearable placeholder="支付方式">
                <!-- 支付方式：1微信 2支付宝 -->
                <el-option label="微信" value="1"></el-option>
                <el-option label="支付宝" value="2"></el-option>
              </el-select>
              <DynamicOption :size="'medium'" style="width: 200px !important;" v-model="searchParams.channelId"
                :placeholder="'请选择渠道'" :singleSelect="true" />
              <el-input v-model="searchParams.mediaSearch" size="medium"
                style="width: 200px !important;;margin-right: .625rem;" clearable placeholder="媒资内容"></el-input>
              <el-select v-model="searchParams.partnerId" size="medium"
                style="width: 200px !important;margin-right: .625rem;" clearable placeholder="媒资来源">
                <el-option v-for="item in mediaSourceList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
              <el-select v-model="searchParams.payStatus" size="medium"
                style="width: 200px !important;margin-right: .625rem;" clearable placeholder="订单状态">
                <!-- 支付状态：0未支付 1已支付 2支付失败 -->
                <el-option label="未支付" value="0"></el-option>
                <el-option label="已支付" value="1"></el-option>
                <el-option label="支付失败" value="2"></el-option>
              </el-select>
              <el-select v-model="searchParams.refundStatus" size="medium"
                style="width: 200px !important;margin-right: .625rem;" clearable placeholder="退款状态">
                <!-- 	退款状态：0未申请 1待处理 2退款中 3退款成功 4退款失败 5拒绝退款 -->
                <el-option label="未申请" value="0"></el-option>
                <el-option label="待处理" value="1"></el-option>
                <el-option label="退款中" value="2"></el-option>
                <el-option label="退款成功" value="3"></el-option>
                <el-option label="退款失败" value="4"></el-option>
                <el-option label="拒绝退款" value="5"></el-option>
              </el-select>
              <el-button v-auth="'MEDIA_ORDER_SEARCH'" style="position: relative;" type="primary" size="small"
                @click="search">搜 索</el-button>
              <el-button v-if="false" v-auth="'MEDIA_ORDER_EXPORT'" style="position: relative;" type="primary"
                size="small" @click="exportExcel">导 出</el-button>
              <el-button v-auth="'MEDIA_ORDER_EXPORT'" style="position: relative;" type="primary" size="small"
                @click="exportAll">导 出</el-button>
            </div>

          </div>
        </template>
        <!-- 自定义表格列 -->
        <template #mediaName="scope">
          <span style="color: blue;">{{ scope.row.mediaName }}</span>
        </template>
        <template #mediaContent="scope">
          <span>{{ scope.row.mediaName ? scope.row.mediaName : '-' }}</span>
        </template>
        <template #mediaType="scope">
          <!-- // 类型：0其它 1电影 2电视剧 3动画片 4短剧 -->
          <span>
            {{
              scope.row.mediaType == 0
              ? "其它"
              : scope.row.mediaType == 1
                ? "电影"
                : scope.row.mediaType == 2
                  ? "电视剧"
                  : scope.row.mediaType == 3
                    ? "动画片"
                    : scope.row.mediaType == 4
                      ? "短剧"
                      : ""
            }}
          </span>
        </template>
        <template #refundTime="scope">
          <span>{{ scope.row.refundTime ? scope.row.refundTime : "" }}</span>
        </template>
        <template #refundStatus="scope">
          <!-- 	退款状态：0未申请 1待处理 2退款中 3退款成功 4退款失败 5拒绝退款 -->
          <span>
            {{
              scope.row.refundStatus == 0
              ? "未申请"
              : scope.row.refundStatus == 1
                ? "待处理"
                : scope.row.refundStatus == 2
                  ? "退款中" : scope.row.refundStatus == 3
                    ? "退款成功" : scope.row.refundStatus == 4
                      ? "退款失败" : scope.row.refundStatus == 5
                        ? "拒绝退款" : ""
            }}
          </span>
        </template>
        <!-- <template #refundReason="scope">
          <span>{{ scope.row.vodRefundOrder.refundReason }}</span>
        </template> -->
        <template #channelId="scope">
          <span>
            {{ `[${scope.row.channelId}] ${scope.row.channelName}` }}
          </span>
        </template>
        <template #validStartTime="scope">
          <!-- 支付方式：1微信 2支付宝 -->
          <span>
            {{ scope.row.validStartTime }} 至 {{ scope.row.validEndTime }}
          </span>
        </template>
        <!-- 自定义表格操作栏 -->
        <template #menu="{ row }">
          <el-button v-if="row.refundStatus === 0 && row.payStatus === 1" v-auth="'MEDIA_ORDER_APPLY'" type="text"
            size="small" @click="handleRefound(row)">申请退款</el-button>
        </template>
      </avue-crud>
      <ElementPagination style="margin-bottom: 20px;" :current-page="searchParams.current" :page-size="searchParams.size"
        :total="searchParams.total" :page-sizes="[10, 20, 30, 40, 50]" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </basic-container>
    <!-- //^ ^--------------申请退款的对话框-------------^ ^ -->
    <el-dialog title="申请退款" append-to-body :visible.sync="refundVisible" width="45%" @closed="handleClose">
      <el-form :model="refoundParams" label-position="left" label-width="120px" :rules="refoundRules" ref="refundForm">
        <div class="refound-dialog-contain">
          <el-form-item label="订单编号：">
            {{ refoundData.payOrderNo }}
          </el-form-item>
          <el-form-item label="用户账号：">
            {{ refoundData.username }}
          </el-form-item>
          <el-form-item label="支付方式：">
            {{ refoundData.$payMethod }}
          </el-form-item>
          <el-form-item label="支付金额：">
            {{ refoundData.payMoney }}元
          </el-form-item>
        </div>
        <div class="refound-dialog-contain">
          <el-form-item label="媒资名称：">
            {{ refoundData.vodMedia ? refoundData.vodMedia.name : "暂无" }}
          </el-form-item>
          <el-form-item label="媒资ID：">
            {{ refoundData.mediaId }}
          </el-form-item>
          <el-form-item label="媒资有效期：">
            {{ refoundData.validStartTime }} 至 {{ refoundData.validEndTime }}
            <span v-if="new Date(refoundData.validEndTime).getTime() < Date.now()" style="color: red;">（已失效）</span>
          </el-form-item>
          <!-- <el-form-item label="支付金额：">
            {{ refoundData.payOrderNo }}
          </el-form-item> -->
        </div>
        <div class="refound-dialog-contain" style="height: 30vh;">
          <el-form-item label="退款方式：">
            <el-radio v-model="refoundParams.refundType" label="1">退款退货</el-radio>
          </el-form-item>
          <el-form-item prop="refundMoney" label="退款金额：">
            <el-input style="width: 60%;" v-model="refoundParams.refundMoney"
              placeholder="请输入退款金额"></el-input>&nbsp;&nbsp;<span>元</span>
          </el-form-item>
          <el-form-item prop="refundReason" label="退款理由：">
            <el-input style="width: 60%; " type="textarea" :autosize="{ minRows: 2, maxRows: 10000 }" maxlength="9999"
              v-model="refoundParams.refundReason" show-word-limit></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :disabled="(
          new Date(refoundData.validEndTime).getTime() < Date.now()
        )
          " type="primary" @click="handleRefund(refoundData.id)">确认申请退款</el-button>
        <el-button @click="handleClose">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Message from "@/components/Message";
import ElementPagination from "@/components/ElementPagination";
import options from "./option";
import moment from "moment";
import {
  getList,
  getMediaSource,
  refund,
  exportExcel
} from "@/api/mediaManage/mediaOrder.js";
import DynamicOption from "@/components/DynamicOption/index.vue";
export default {
  name: "WebOpenPlatformIndex",
  components: {
    ElementPagination,
    DynamicOption
  },
  /** 监听路由的query是否有参数 */
  watch: {
    $route: {
      handler: function (route) {
        if (route.query.id) {
          this.searchParams.orderSearch = route.query.id;
          this.loadList();
        }
      },
      immediate: true
    }
  },
  created() {
    this.loadList();
    this.getMediaSource();
  },
  data() {
    return {

      /** 媒资来源下拉列表的数据 */
      mediaSourceList: [],
      // ^ ^--------------申请退款对话框内的数据-------------^ ^
      /** 申请退款的数据 */
      refoundParams: {
        payOrderId: "",
        refundMoney: "",
        refundReason: "",
        refundType: ""
      },
      /** 申请退款的表单验证规则 */
      refoundRules: {
        refundMoney: [
          // 要求正数，最多两位小数
          {
            required: true,
            pattern: /^(([1-9]\d*)|0)(\.\d{1,2})?$/,
            message: "请输入正数且最多保留两位小数的退款金额",
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              if (value > this.refoundData.payMoney) {
                callback(new Error("退款金额不能大于支付金额"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        refundReason: [
          {
            required: true,
            message: "请输入退款原因",
            trigger: "blur"
          }
        ]
      },
      /** 申请退款对话框的显隐 */
      refundVisible: false,
      ids: 1,
      /** 媒资内容详情对话框的显隐 */
      detailVisible: false,
      option: options(this),
      /** 搜索参数的配置 */
      searchParams: {
        current: 1,
        size: 10,
        total: 0,
        /** 下单时间 默认最近七天*/
        addStartTime: this.calculateRecentSevenDays(),
        /** 订单编号/商户编号 */
        orderSearch: "",
        /** UUID/用户账号 */
        userSearch: "",
        /** 支付时间 */
        payStartTime: '',
        /** 退款时间 */
        refundStartTime: '',
        /** 支付方式 */
        payMethod: "",
        /** 渠道id */
        channelId: "",
        /** 订单状态 */
        payStatus: "",
        /** 退款状态 */
        refundStatus: "",
        /** 媒资内容 */
        mediaSearch: "",
        /** 媒资来源 */
        partnerId: ""
      },
      /** 表格里的数据 */
      list: [],
      /** 申请退款里面展示的数据 */
      refoundData: {
        vodRefundOrder: {
          status: ""
        }
      }
    };
  },

  methods: {
    calculateRecentSevenDays() {
      const today = moment();
      const sevenDaysAgo = moment().subtract(6, "days");

      const startDate = sevenDaysAgo.format("YYYY-MM-DD");
      const endDate = today.format("YYYY-MM-DD");

      return [startDate, endDate];
    },
    /** 导出的事件 */
    exportExcel() {
      /** 按类名获取html按钮元素 */
      const btn = document.getElementsByClassName(
        "el-button el-button--primary el-button--small"
      );
      console.log("导出的事件", btn);
      /** 触发这个元素的点击事件 */
      btn[4].click();
    },
    /** 全部导出 */
    async exportAll() {

      const params = { ...this.searchParams }
      /** 删除分页相关的属性 */
      delete params.current
      delete params.size
      delete params.total
      /** 调用接口 */
      const res = await exportExcel(params);
      console.log("全部导出的响应", res);
      /** 导出excel */
      const { data, headers } = res

      const blob = new Blob([data], { type: headers['content-type'] })
      const dom = document.createElement('a')
      const downUrl = window.URL.createObjectURL(blob)
      dom.href = downUrl
      dom.download = decodeURIComponent('媒资订单_' + moment().format('YYYY-MM-DD') + '.xlsx')
      dom.style.display = 'none'
      document.body.appendChild(dom)
      dom.click()
      dom.parentNode.removeChild(dom)
      window.URL.revokeObjectURL(downUrl)

    },
    //^ ^--------------申请对话框内的事件-------------^ ^
    /** 申请退款的事件 */
    handleRefund(id) {
      this.refoundParams.payOrderId = String(id);
      console.log("申请退款的事件", this.refoundParams);
      this.$refs.refundForm.validate(async valid => {
        if (valid) {
          /** 调用接口 */
          const { data } = await refund(this.refoundParams);
          console.log("申请退款的响应", data);
          /** 如果成功 */
          if (data.code === 200) {
            /** 关闭对话框 */
            this.handleClose();
            /** 提示用户 */
            Message.success("申请退款成功");
            /** 更新数据 */
            await this.loadList();
          }
        }
      });
    },
    /** 关闭申请退款对话框的事件 */
    handleClose() {
      /** 清理数据 */
      this.refoundParams = {
        payOrderId: "",
        refundMoney: "",
        refundReason: ""
      };
      /** 清理表单验证规则 */
      this.$refs.refundForm.clearValidate();
      /** 关闭对话框 */
      this.refundVisible = false;
    },
    /** //^ ^--------------表格操作栏的事件-------------^ ^ */
    /** 申请退款的事件 */
    handleRefound(row) {
      console.log("申请退款的事件", row);
      this.refoundData = row;
      /** 退款方式默认单选 */
      this.refoundParams.refundType = "1";
      this.refundVisible = true;
    },
    /** avue刷新控件的方法 */
    async refreshChange() {
      console.log("refreshChange");
      /** 更新数据 */
      await this.loadList();
      /** 提示用户 */
      Message.success("刷新成功");
    },
    //^ ^--------------分页相关-------------^ ^
    /** 搜索事件 */
    async search() {
      console.log("搜索事件", this.searchParams);
      /** 处理时间格式 */
      this.searchParams.addStartDate = this.searchParams.addStartTime
        ? this.searchParams.addStartTime[0]
        : null;
      this.searchParams.addEndDate = this.searchParams.addStartTime
        ? this.searchParams.addStartTime[1]
        : null;
      this.searchParams.payStartDate = this.searchParams.payStartTime
        ? this.searchParams.payStartTime[0]
        : null;
      this.searchParams.payEndDate = this.searchParams.payStartTime
        ? this.searchParams.payStartTime[1]
        : null;
      this.searchParams.refundStartDate = this.searchParams.refundStartTime
        ? this.searchParams.refundStartTime[0]
        : null;
      this.searchParams.refundEndDate = this.searchParams.refundStartTime
        ? this.searchParams.refundStartTime[1]
        : null;
      /** 更新数据 */
      this.searchParams.current = 1
      await this.loadList();
      /** 提示用户 */
      Message.success("搜索成功");
    },
    /** 获取列表数据 */
    async loadList() {
      const { data } = await getList(this.searchParams);
      console.log("分页查询数据的响应", data);
      this.list = data.data.records;
      this.searchParams.total = data.data.total;
    },
    /** 每页条数change */
    handleSizeChange(val) {
      this.searchParams.size = val;
      Message.success(`每页 ${val} 条`);
      /** 更新数据 */
      this.loadList();
    },
    /** 当前页change */
    handleCurrentChange(val) {
      this.searchParams.current = val;
      Message.success(`当前页 ${val}`);
      /** 更新数据 */
      this.loadList();
    },
    // ^ ^--------------初始化数据-------------^ ^
    async getMediaSource() {
      const { data } = await getMediaSource();
      console.log("媒资来源下拉列表的数据", data);
      this.mediaSourceList = data.data;
    }
  }
};
</script>

<style lang="scss" scoped>
/** 申请按钮置灰 */
.el-button[disabled] {
  background-color: #ebeef5 !important;
  color: #c0c4cc !important;
  border-color: #d3dce6 !important;
}

.search-left {
  display: flex !important;
  flex-wrap: wrap !important;
  gap: 10px 0px // justify-content: space-between !important;
    // align-items: center !important;
}

// ^ ^--------------预设的样式-------------^ ^
.flex {
  margin-top: 10px;
  padding: 2% 15%;
  width: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap !important;
  background-color: #f7f7f7;
}

::v-deep .el-textarea__inner {
  padding-right: 55px !important;
  max-height: 100px !important;
}

.refound-dialog-contain {
  background-color: #f7f7f7;
  padding: 0 10%;
}

.avue-crud .avue-input-number,
.avue-crud .el-cascader,
.avue-crud .el-date-editor.el-input,
.avue-crud .el-date-editor.el-input__inner,
.avue-crud .el-select,
.avue-form .avue-input-number,
.avue-form .el-cascader,
.avue-form .el-date-editor.el-input,
.avue-form .el-date-editor.el-input__inner,
.avue-form .el-select {
  width: 70% !important;
}

::v-deep .avue-form__menu--center {
  display: none !important;
}

::v-deep .avue-form__group .el-col-md-6 {
  width: 100%;
}

::v-deep .avue-form__group .el-form-item__content {
  margin-left: 0px !important;
}

::v-deep .avue-crud .avue-crud__search .avue-form .avue-form__group .avue-form__row .el-form-item label {
  float: none;
  display: inline-block;
}

::v-deep .avue-crud__menu {
  //   position: relative;
  //   overflow: visible;

  .avue-crud__left {
    //     position: relative;

    .el-button {
      display: none !important;
      //       position: absolute;
      //       top: -189%;
      //       left: 40vw;
      //       // top: -2.82vw;
      //       // top: -260%;
      //       // left: 47%;
      //       // left: 41vw;
      //       // transform: translate(-50%);

      span {
        margin: 0;
      }

      .el-icon-download {
        display: none;
      }
    }
  }
}

// ::v-deep .el-card .is-never-shadow {
//   overflow: visible !important;
// }
</style>
